import styles from "./EnergyLabelDrawer.module.scss";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { OpenInNewOutlined as OpenInNew24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/OpenInNewOutlined";
import { modifyImageUrlQueryParams } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";

export type DrawerProps = {
  isOpen: boolean;
  isLegacy: boolean;
  handleClose: () => void;
  rating: string;
  label?: string;
  informationSheet?: string;
};

export const EnergyLabelDrawer = ({
  isOpen,
  handleClose,
  rating,
  label,
  informationSheet,
  isLegacy,
}: DrawerProps) => {
  const noLabelText = isLegacy
    ? `This item is rated ${rating} for energy efficiency on a scale from A+++ (most efficient) to D (least efficient).`
    : `This item is rated ${rating} for energy efficiency on a scale from A (most efficient) to G (least efficient).`;

  return (
    <Drawer
      isOpen={isOpen}
      onClose={handleClose}
      heading={`Energy Rating: ${rating}`}
    >
      {(!!label || !!informationSheet) && (
        <div className={styles.links}>
          {!!label && (
            <UnderlinedButton
              className={styles.externalButton}
              tag="a"
              target="_blank"
              href={label}
            >
              Energy Label
              <OpenInNew24PxOutlinedIcon size="medium" />
            </UnderlinedButton>
          )}
          {!!informationSheet && (
            <UnderlinedButton
              className={styles.externalButton}
              tag="a"
              target="_blank"
              href={informationSheet}
            >
              Product Information Sheet
              <OpenInNew24PxOutlinedIcon size="medium" />
            </UnderlinedButton>
          )}
        </div>
      )}
      {label ? (
        <img
          src={modifyImageUrlQueryParams(label, { wid: 600 })}
          alt={noLabelText}
          className={styles.energyLabel}
        />
      ) : (
        <div data-testid="energy-label-efficiency-explanation">
          {noLabelText}
        </div>
      )}
    </Drawer>
  );
};
